import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import ScrollAnimation from "react-animate-on-scroll";
import { setting } from "../Config/Config";
const RedHat = "./img/Technologies/Red-Hat.png";
const Oracle = "./img/Technologies/Oracle.png";
const Dell = "./img/Technologies/Dell.png";
const HP = "./img/Technologies/HP.png";
const Fortinet = "./img/Technologies/Fortinet.png";
const Cisco = "./img/Technologies/Cisco.png";
const Microsoft = "./img/Technologies/Microsoft.png";
const Lenovo = "./img/Technologies/Lenovo.png";

const Juniper = "./img/Technologies/Juniper.png";
const Emerson = "./img/Technologies/Emerson.png";
const Kaspersky = "./img/Technologies/Kaspersky.png";
const Brocade = "./img/Technologies/Brocade.png";
const Veeam = "./img/Technologies/Veeam.png";
const Symantec = "./img/Technologies/Symantec.png";
const Sophos = "./img/Technologies/Sophos.png";
const SAP = "./img/Technologies/SAP.png";

const Partners = () => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2 style={{ color: setting.blue }}>Our Partners</h2>
        </div>
        <ScrollAnimation animateIn="fadeInLeft">
          <Carousel
            showThumbs={false}
            transitionTime={1000}
            autoPlay
            showStatus={false}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                margin: 20,
              }}
            >
              <img
                alt="Partners"
                src={Dell}
                style={{ width: 120, height: 20, margin: 10 }}
              />
              <img
                alt="Partners"
                src={Lenovo}
                style={{ width: 100, height: 20, margin: 10 }}
              />
              <img
                alt="Partners"
                src={Microsoft}
                style={{ width: 180, height: 60, margin: 10 }}
              />

              <img
                alt="Partners"
                src={Symantec}
                style={{ width: 140, height: 35, margin: 10 }}
              />
              <img
                alt="Partners"
                src={RedHat}
                style={{ width: 150, height: 70, margin: 10 }}
              />
              <img
                alt="Partners"
                src={Kaspersky}
                style={{ width: 100, height: 50, margin: 10 }}
              />
              <img
                alt="Partners"
                src={Fortinet}
                style={{ width: 220, height: 110 }}
              />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                margin: 20,
              }}
            >
              <img
                alt="Partners"
                src={Emerson}
                style={{ width: 100, height: 90, margin: 10 }}
              />
              <img
                alt="Partners"
                src={Veeam}
                style={{ width: 90, height: 20, margin: 10 }}
              />
              <img
                alt="Partners"
                src={Brocade}
                style={{ width: 100, height: 30, margin: 10 }}
              />
              <img
                alt="Partners"
                src={Cisco}
                style={{ width: 90, height: 40, margin: 10 }}
              />
              <img
                alt="Partners"
                src={Juniper}
                style={{ width: 100, height: 30, margin: 10 }}
              />
              <img
                alt="Partners"
                src={Oracle}
                style={{ width: 70, height: 70, margin: 10 }}
              />
              <img
                alt="Partners"
                src={HP}
                style={{ width: 50, height: 50, margin: 10 }}
              />
              <img
                alt="Partners"
                src={Sophos}
                style={{ width: 70, height: 50, margin: 10, margin: 10 }}
              />
              <img
                alt="Partners"
                src={SAP}
                style={{ width: 70, height: 50, margin: 10 }}
              />
            </div>
          </Carousel>
        </ScrollAnimation>
      </div>
    </div>
  );
};

export default Partners;
